"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionManagerEditorService = exports.SessionManagerService = void 0;
const static_service_1 = require("@wix/static-service");
const viewer_service_environment_1 = require("@wix/viewer-service-environment");
const definitions_1 = require("../definitions");
const clientSessionManager_1 = require("../clientSessionManager");
const serverSessionManager_1 = require("../serverSessionManager");
const editorSessionManager_1 = require("../editorSessionManager");
exports.SessionManagerService = (0, static_service_1.implementStaticService)(definitions_1.SessionManagerDefinition, ({ config, getService }) => {
    const envService = getService(viewer_service_environment_1.EnvironmentDefinition);
    return envService.isSSR() ? (0, serverSessionManager_1.createServerSessionManager)(config) : (0, clientSessionManager_1.createClientSessionManager)(config);
});
exports.SessionManagerEditorService = (0, static_service_1.implementStaticService)(definitions_1.SessionManagerDefinition, ({ config }) => (0, editorSessionManager_1.createEditorSessionManager)(config));
//# sourceMappingURL=sessionManagerService.js.map